export default "__VITE_ASSET__fm6X2KQ4__"